import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
	// public root_url:string = 'http://164.52.202.9:1337/amsapi/'; 
	public root_url:string = 'https://api.pareekshn.com/amsapi/'; 
	// public root_url:string = 'http://localhost:1337/amsuser/';
	//public root_url:string = 'http://localhost:1337/amsapi/'; 	

	public publisherObj;
	public isExamOver = false;
	public isPracticalOver = false;
    public theoryexam: number = 0;  
    public vivaexam: number = 0;  

    public googleKey = 'AIzaSyBobH9FTqp_npqwcgDlwjeKAZse_v_yp6Q';

	/* Authenticate url */
	public complSteps = {};
	public getRandUrl(route){
		var date = new Date(); 
        var timestamp = date.getTime();
        var text = "";
  		var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ-abcdefghijklmnopqrstuvwxyz-0123456789-"+timestamp;
		for (var i = 0; i < 70; i++)
		     text += possible.charAt(Math.floor(Math.random() * possible.length));

		this.complSteps[route] = text;
		return text;
	}
	public aadharAPIkey = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTYzNjYyMDYxNSwianRpIjoiNzU5Nzg2MjYtNDBjYy00Y2M5LWFlOTktZDgzZTI2NzdiZTk0IiwidHlwZSI6ImFjY2VzcyIsImlkZW50aXR5IjoiZGV2LmFhZHJpa2FnbG9iYWxAYWFkaGFhcmFwaS5pbyIsIm5iZiI6MTYzNjYyMDYxNSwiZXhwIjoxOTUxOTgwNjE1LCJ1c2VyX2NsYWltcyI6eyJzY29wZXMiOlsicmVhZCJdfX0.h6XXVyyZwwo0fM1wMbRV4lTBIB8DEaHK5pTU9hKNaYM";	
	public mockAPIkey = "MTQ1YjE4ZDI2Mjc1MzQ4MGM2Njc5MTNlNDdmMWY2MGVfUGFyQDIzQE1F";
}